import axios from "../../utils/axios";

export const getTransactions = async (page, pageNum = 1, search, type) => {
  let filterStr = "";

  if (page === "home") {
    filterStr += "_sort=id&_order=desc&_limit=5";
  } else if (page === "transactions") {
    filterStr += `_page=${pageNum}&_limit=10`;
    if (type) filterStr += `&type=${type}`;
    if (search) filterStr += `&name_like=${search}`;
  }

  const response = await axios.get(`/transactions?${filterStr}`);
  const data = {
    transactions: response.data,
    totalTransactions: parseInt(response.headers["x-total-count"]),
  };
  return data;
};

export const addTransaction = async (data) => {
  const response = await axios.post("/transactions", data);

  return response.data;
};

export const editTransaction = async (id, data) => {
  const response = await axios.put(`/transactions/${id}`, data);

  return response.data;
};

export const deleteTransaction = async (id) => {
  const response = await axios.delete(`/transactions/${id}`);

  return response.data;
};
